import { ChainConfiguration } from '@occc-app/Chain/types';

import { Point_Expiration_Strategy } from '@occc/graphql';
import { useChain } from './useChain';

const defaultChainConfiguration: ChainConfiguration = {
  manualPointChangeCap: null,
  allowedPointAdjustmentReasons: [],
  referralProgramConfigurationEnabled: false,
  referralProgramConfiguration: null,
  offerReturnStrategy: 'OFF',
  offerReturnDefaultStrategy: false,
  allowMultipleTransactionDiscounts: false,
  pointExpiration: {
    strategy: Point_Expiration_Strategy.None,
    notificationDays: 0,
  },
};

export const useChainConfiguration = (): ChainConfiguration => {
  const chain = useChain();
  return chain?.configuration || defaultChainConfiguration;
};
